:host {
  z-index: $zIndexPopup;
  position: absolute;
  top: space('medium');
  right: $gridGutterSmall;

	@include mq($from: medium) { // was smallheader before
		right: 50%;
	}

	@include mq($from: large) {
		top: space('xlarge');
		right: 60%;
  }
}
